/**
 * @param {ProductVariantCollection} productVariant
 * @returns {boolean}
 */
export default function isArchivedProductVariantUtil (productVariant) {
  return !productVariant?.online_store_url?.includes('airshop')
}
